import { useScreenSize } from '../../../hooks/useScreenSize';
import { User, LogOut } from 'lucide-react';

export default function Navbar() {
  const { isMobile } = useScreenSize();

  return (
    <div className="flex-row space-between w-100 ptb-1">
      <div>
        <h1 className="h1-dash">My Dashboard</h1>
        <p>Welcome to your dashboard overview 🎉</p>
      </div>
      <div className="logout flex-row-align gap-1">
        <User className="text-gray-700" />
        {isMobile ? (
          <a href="/.auth/logout" className="flex-row-align gap-1">
            <LogOut className="text-gray-700" />
          </a>
        ) : (
          <a href="/.auth/logout" className="flex-row-align gap-1">
            <LogOut className="text-gray-700" /> Log out
          </a>
        )}
      </div>
    </div>
  );
}
